import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('clientEnvironmentCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/system/client-environment'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.clientEnvironment,
    cacheName: 'clientEnvironment'
  })
);
